export default "__VITE_ASSET__DiD$o3wv__"